import React from "react";
import { Header as SemanticHeader } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { getUiOptions } from "../../../../utils";

interface FieldHeaderProps {
  content: string;
  schema?: { [key: string]: any };
  semanticProps: { [key: string]: any };
};

const FieldHeader: React.FC<FieldHeaderProps> = ({ content, semanticProps = {} }) => {
  const { t } = useSchemaTranslation();

  if (!semanticProps || !Object.keys(semanticProps).length) {
    return (
      <label> {t(content)} </label>
    );
  };

  return (
    <SemanticHeader
      className="sui-header-widget"
      content={t(content)}
      as={semanticProps.as}
      size={semanticProps.size}
      dividing={semanticProps.dividing}
    />
  );
}

export default FieldHeader;
